<template>
    <div class="rounded-lg bg-white p-3 shadow">
        <p class="mb-4">Sections</p>
        <draggable
            handle=".handle"
            :value="sections"
            @input="data => $emit('input', data)"
            @update="updateOrder"
            ghost-class="opacity-50"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div
                v-for="(section, index) in sections"
                :key="`section_${index}`"
                class="rounded-lg bg-white shadow mb-4 relative"
            >
                <div
                    class="flex justify-between items-center cursor-pointer hover:bg-gray-50 p-4"
                    @click="toggleSectionCollapse(index)"
                >
                    <div class="handle">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                    </div>
                    <div>
                        {{ section.heading }}
                    </div>
                    <div>
                        <svg v-if="!section.collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                        <svg v-if="section.collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                        </svg>
                    </div>
                </div>

                <div class="px-4 pb-4" v-show="section.collapsed">
                    <div class="flex flex-row items-center justify-end mt-3">
                        <button
                            type="button"
                            class="bg-red-500 text-white flex flex-row items-center rounded px-3 py-2"
                            @click="deleteSection(index)"
                        >
                            <svg
                                class="w-4 h-4"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                            </svg>
                            <span class="ml-2">Delete Section</span>
                        </button>
                    </div>

                    <input-text
                        name="heading"
                        label="Heading"
                        class="mb-3"
                        v-model="section.heading"
                        :error="
                            errors[`sections.${index}.heading`]
                                ? errors[`sections.${index}.heading`][0]
                                : null
                        "
                    />

                    <input-text
                        name="heading_anchor_text"
                        label="Quick Navi Menu anchor text for Heading"
                        class="mb-3"
                        v-model="section.heading_anchor_text"
                        :error="errors.heading_anchor_text ? errors.heading_anchor_text[0] : null"
                    />

                    <input-text
                        class="mb-3"
                        name="anchor_url"
                        label="Jump ID (excluding #)"
                        v-model="section.anchor_url"
                        :error="
                            errors[`sections.${index}.anchor_url`]
                                ? errors[`sections.${index}.anchor_url`][0]
                                : null
                        "
                        editor="content"
                    />

                    <input-rich-text
                        name="text"
                        label="Text"
                        v-model="section.text"
                        :key="`section_text_${index}`"
                         :error="
                            errors[`sections.${index}.text`]
                                ? errors[`sections.${index}.text`][0]
                                : null
                        "
                        :language="language"
                    />

                    <media-reference
                        :key="`media${section.id || section.key}`"
                        v-model="section.image"
                        :language="language"
                        class="mt-3"
                        label="Image"
                    />
                </div>
            </div>
        </draggable>
        <Btn
            content="Add Section"
            class="mt-3"
            type="button"
            @click="addSection"
        />
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {useFroalaStore} from "../stores/froala";
export default {
    name: "AboutUsSections",
    components: {draggable},
    props: {
        value: {
            type: Array,
            required: true,
        },
        errors: {
            type: [Array, Object],
            required: true,
        },
        language: Object,
    },
    data: function(){
        return {
            sections: this.value,
            froalaStore: useFroalaStore(),
        }
    },
    mounted: function(){
        this.sections.map(section => {
            section.collapsed = false;
            return section;
        });
    },
    methods: {
        addSection: function(){
            this.sections.push({
                key: Math.random().toString(16).substr(2, 8),
                heading: '',
                text: '',
            });
            this.updateOrder();
        },
        deleteSection: function(index){
            this.sections.splice(index, 1);
            this.updateOrder();
        },
        updateOrder: function(){
            const sections = [...this.sections];
            this.sections = sections.map((section, index) => {
                section.order = index;
                return section;
            });
            this.$emit('input', this.sections)
        },
        toggleSectionCollapse: function(sectionIndex){
            const sections = [...this.sections];
            sections[sectionIndex].collapsed = !sections[sectionIndex].collapsed;
            this.sections = sections;
        },
    },
    watch: {
        value: function(newValue){
            this.sections = newValue;
        }
    },

}
</script>
